(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ayunel-article"]) return;
  try {
    
  if (!customElements.get('ayunel-share')) {
    customElements.define(
      'ayunel-share',
      class extends HTMLElement {
        connectedCallback() {
          if (this.aynReady) return;
          this.aynReady = true;
          const item = this.querySelector('[data-ayn-ar-copy-item]');
          const btn = item && item.querySelector('button');
          const label = this.querySelector('.ayunel-article__share-label');
          const status = this.querySelector('[data-ayn-ar-status]');
          if (!btn || !label || !status || !navigator.clipboard || !window.isSecureContext) return;
          item.hidden = false;
          btn.addEventListener('click', () => {
            navigator.clipboard.writeText(btn.dataset.url).then(
              () => {
                label.textContent = btn.dataset.done;
                status.textContent = btn.dataset.done;
                clearTimeout(this.aynTimer);
                this.aynTimer = setTimeout(() => {
                  label.textContent = label.dataset.default;
                  status.textContent = '';
                }, 2000);
              },
              () => {}
            );
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ayunel-contact-form"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const WEBHOOK = 'https://script.google.com/macros/s/AKfycbyYGUNMqR2DuJOoTs2nt86CTYG6IsG9rKWl4KxzqNm0Q0UQmSdTGsDD6od5Z6IcQfaYKg/exec';
    const MAX_SIZE = 35 * 1024 * 1024;
    const CONSENT_NOTE = '\n\n----\n☑ プライバシーポリシーに同意のうえ送信';
    const ERROR_ICON = '<svg class="ayunel-contact__result-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><circle cx="12" cy="12" r="9"/><path d="M12 7.5v5.5"/><path d="M12 16.5h.01"/></svg>';

    function reduceMotion() {
      return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    }

    function init(root) {
      const form = root.querySelector('[data-ayunel-contact-form]');
      const submit = root.querySelector('[data-ayunel-contact-submit]');
      if (!form || !submit || form.dataset.aynReady) return;
      form.dataset.aynReady = '1';

      const label = submit.querySelector('[data-ayunel-contact-label]');
      const sending = submit.querySelector('[data-ayunel-contact-sending]');
      const live = root.querySelector('[data-ayunel-contact-result]');
      const fileInput = form.querySelector('input[type="file"]');
      const dialog = root.querySelector('[data-ayunel-contact-dialog]');
      const closeBtn = root.querySelector('[data-ayunel-contact-close]');
      let closeTimer = null;
      let errorTimer = null;

      function setLoading(on) {
        submit.disabled = on;
        submit.setAttribute('aria-busy', on ? 'true' : 'false');
        if (label) label.hidden = on;
        if (sending) sending.hidden = !on;
      }

      function clearError() {
        clearTimeout(errorTimer);
        live.textContent = '';
      }

      // 播报区常驻、先清空再隔一拍写入:读屏才会念出来(同一句连报两次也念);图标 + 文字 + 色三重(§K.2-58 ⑥)
      function showError(msg) {
        clearError();
        errorTimer = setTimeout(function () {
          const box = document.createElement('p');
          box.className = 'ayunel-contact__result';
          box.innerHTML = ERROR_ICON;
          const text = document.createElement('span');
          text.textContent = msg;
          box.appendChild(text);
          live.appendChild(box);
          box.scrollIntoView({ block: 'center' });
        }, 50);
      }

      function isOpen() {
        return !!dialog && dialog.hasAttribute('open');
      }

      // 开关写法照 snippets/ayunel-trust-modal-shell.liquid:强制回流后加 .is-open(不用 rAF —— 页面不在前台时
      // rAF 不跑,弹窗开着却看不见,2026-09-02 实测);老 iOS 没有 <dialog> 时走 .ayn-fallback 定位
      function openDialog() {
        if (!dialog || isOpen()) return;
        clearTimeout(closeTimer);
        if (typeof dialog.showModal === 'function') {
          dialog.showModal();
        } else {
          dialog.classList.add('ayn-fallback');
          dialog.setAttribute('open', '');
        }
        dialog.classList.remove('is-closing');
        void dialog.offsetWidth;
        dialog.classList.add('is-open');
        if (closeBtn) closeBtn.focus();
      }

      function closeDialog() {
        if (!isOpen() || dialog.classList.contains('is-closing')) return;
        dialog.classList.remove('is-open');
        dialog.classList.add('is-closing');
        clearTimeout(closeTimer);
        closeTimer = setTimeout(function () {
          dialog.classList.remove('is-closing');
          if (typeof dialog.close === 'function') dialog.close();
          else dialog.removeAttribute('open');
          dialog.classList.remove('ayn-fallback');
          if (!root.contains(document.activeElement)) submit.focus({ preventScroll: true });
        }, reduceMotion() ? 0 : 220);
      }

      if (dialog) {
        dialog.addEventListener('cancel', function (e) {
          e.preventDefault();
          closeDialog();
        });
        // 别简化成 e.target === dialog 就关:要判「真的点在框外」(外壳注释 2026-09-06 对抗审 T5)
        dialog.addEventListener('click', function (e) {
          if (e.target !== dialog || e.detail === 0) return;
          const r = dialog.getBoundingClientRect();
          if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) closeDialog();
        });
        document.addEventListener('click', function (e) {
          if (dialog.classList.contains('ayn-fallback') && isOpen() && !dialog.contains(e.target)) closeDialog();
        });
        document.addEventListener('keydown', function (e) {
          if (e.key === 'Escape' && dialog.classList.contains('ayn-fallback') && isOpen()) closeDialog();
        });
      }
      if (closeBtn) closeBtn.addEventListener('click', closeDialog);

      function collectParams(extra) {
        const params = new URLSearchParams();
        new FormData(form).forEach(function (val, key) {
          if (typeof val !== 'string') return;
          const m = key.match(/^contact\[(.+)\]$/);
          params.append(m ? m[1] : key, val);
        });
        if (params.get('consent')) params.set('body', (params.get('body') || '') + CONSENT_NOTE);
        if (extra) Object.keys(extra).forEach(function (k) { params.append(k, extra[k]); });
        return params;
      }

      function postWebhook(extra) {
        fetch(WEBHOOK, { method: 'POST', body: collectParams(extra) })
          .then(function (r) { return r.json(); })
          .then(function (json) {
            setLoading(false);
            if (json && json.ok) {
              form.reset();
              clearError();
              openDialog();
              return;
            }
            const code = (json && json.error) || 'unknown';
            showError(
              code === 'file_too_large' ? 'ファイルサイズが大きすぎます。35MB 以下にしてください。' :
              code === 'missing_required' ? '必須項目が入力されていません。ご確認のうえ再度お試しください。' :
              '送信に失敗しました。しばらく経ってから再度お試しください。'
            );
          })
          .catch(function () {
            setLoading(false);
            showError('通信エラーが発生しました。インターネット接続をご確認のうえ、再度お試しください。');
          });
      }

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        clearError();
        if (!form.checkValidity()) {
          form.reportValidity();
          return;
        }
        const file = (fileInput && fileInput.files && fileInput.files[0]) || null;
        if (file && file.size > MAX_SIZE) {
          showError('ファイルサイズが 35MB を超えています(' + (file.size / 1024 / 1024).toFixed(1) + 'MB)。圧縮または分割のうえ再度お試しください。');
          return;
        }
        setLoading(true);
        if (!file) {
          postWebhook();
          return;
        }
        const reader = new FileReader();
        reader.onload = function () {
          const s = reader.result || '';
          postWebhook({ fileBase64: s.substring(s.indexOf(',') + 1), fileName: file.name, fileType: file.type || 'application/octet-stream' });
        };
        reader.onerror = function () {
          setLoading(false);
          showError('ファイルの読み込みに失敗しました。');
        };
        reader.readAsDataURL(file);
      });

      submit.disabled = false;
    }

    function initAll(scope) {
      (scope || document).querySelectorAll('[data-ayunel-contact]').forEach(init);
    }

    initAll();
    // 主题编辑器里改设置会重渲染本 section(先例 sections/ayunel-hero-banner.liquid)
    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ayunel-faq-index"] && !Shopify.designMode) return;
  try {
    
  /* 总览页进入埋点:ayn_faq_enter {ayn_from}(?from= 参数,只认 [A-Za-z0-9_-]{1,40})。
     DOMContentLoaded 后发;aynTrack(assets/ayunel-track.js,defer)可能比本脚本晚一拍,没就绪就 200ms 后再试一次。 */
  (function () {
    'use strict';
    var root = document.querySelector('[data-ayunel-faq-page="index"]');
    if (!root || root.__aynFaqEnter) return;
    root.__aynFaqEnter = true;

    function track(n, p) {
      try {
        if (window.Shopify && window.Shopify.designMode) return;
        if (typeof window.aynTrack === 'function') window.aynTrack(n, p);
      } catch (e) {}
    }
    function fromParam() {
      try {
        var m = /[?&]from=([A-Za-z0-9_-]{1,40})/.exec(window.location.search);
        return m ? m[1] : '';
      } catch (e) { return ''; }
    }
    function enter() {
      if (typeof window.aynTrack === 'function') { track('ayn_faq_enter', { ayn_from: fromParam() }); return; }
      setTimeout(function () { track('ayn_faq_enter', { ayn_from: fromParam() }); }, 200);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', enter);
    else enter();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ayunel-faq-list"] && !Shopify.designMode) return;
  try {
    
  /* 分类页:① 进入埋点 ayn_faq_enter {ayn_from} ② 深链 #anchor 展开 + 回退(题目换了分类时经 feed 查新地址)。 */
  (function () {
    'use strict';
    var root = document.querySelector('.ayunel-faq-cat[data-ayunel-faq-page]');
    if (!root || root.__aynFaqCatInit) return;
    root.__aynFaqCatInit = true;

    function track(n, p) {
      try {
        if (window.Shopify && window.Shopify.designMode) return;
        if (typeof window.aynTrack === 'function') window.aynTrack(n, p);
      } catch (e) {}
    }
    function fromParam() {
      try {
        var m = /[?&]from=([A-Za-z0-9_-]{1,40})/.exec(window.location.search);
        return m ? m[1] : '';
      } catch (e) { return ''; }
    }
    function enter() {
      if (typeof window.aynTrack === 'function') { track('ayn_faq_enter', { ayn_from: fromParam() }); return; }
      setTimeout(function () { track('ayn_faq_enter', { ayn_from: fromParam() }); }, 200);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', enter);
    else enter();

    /* 深链:anchor 只认 ^[a-z0-9-]{3,40}$(与后台字段的正则一致),别的 hash 不理 */
    function currentAnchor() {
      var h = window.location.hash ? window.location.hash.slice(1) : '';
      try { h = decodeURIComponent(h); } catch (e) {}
      return /^[a-z0-9-]{3,40}$/.test(h) ? h : '';
    }

    function openAnchor() {
      var anchor = currentAnchor();
      if (!anchor) return;
      var li = document.getElementById(anchor);
      if (li && li.hasAttribute('data-ayunel-faq-item')) {
        var d = li.querySelector('details');
        if (d && !d.open) d.open = true;
        try { li.scrollIntoView({ block: 'start' }); } catch (e) {}
        return;
      }
      /* 本页没有这个 anchor → 借搜索组件的 feed 加载函数查它现在住哪个分类 */
      var search = document.querySelector('[data-ayunel-faq-search]');
      var load = search && search.aynFaqFeed;
      if (typeof load !== 'function') return;
      load().then(function (feed) {
        var items = (feed && feed.items) || [];
        for (var i = 0; i < items.length; i++) {
          if (items[i].a === anchor && items[i].u) {
            var target = String(items[i].u);
            if (target.split('#')[0] !== window.location.pathname) window.location.replace(target);
            return;
          }
        }
      }).catch(function () {});
    }

    window.addEventListener('load', openAnchor);
    window.addEventListener('hashchange', openAnchor);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ayunel-hero-banner"] && !Shopify.designMode) return;
  try {
    
  /* ==========================================================================
     AYUNEL メインバナー — 淡入淡出控制
     整段包在 IIFE 里:Horizon 会把所有 section 的 js 块合并进同一个 bundle,
     裸声明 class 会污染全局作用域。
     ========================================================================== */
  (function () {
    class AyunelHero {
      constructor(root) {
        this.root = root;
        this.slides = Array.from(root.querySelectorAll('[data-ayunel-hero-slide]'));
        this.dots = Array.from(root.querySelectorAll('[data-ayunel-hero-dot]'));
        this.index = 0;
        this.timer = null;
        this.interval = parseInt(root.dataset.autoplay || '0', 10);
        this.fadeMs = parseInt(root.dataset.fade || '600', 10);
        this.prevTimer = null;
        this.reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        /* 暂停原因用集合表示,不用「timer 是不是 null」代替。
           以前一个 timer 兼职表示所有暂停原因,结果是任何一个 resume 都会把仍然成立的
           另一个原因覆盖掉 —— 例如鼠标移出时焦点还在轮播里,却照样恢复了自动播放。
           现在:任一原因成立就停,全部解除才可能重新跑。 */
        this.pauseReasons = new Set();
        /* 淡入进行中的锁 + 排队目标:半程再切会把上一张强行拉回不透明,肉眼是一次跳帧 */
        this.transitioning = false;
        this.pendingIndex = null;

        this.onDotClick = this.onDotClick.bind(this);
        this.onKeydown = this.onKeydown.bind(this);
        this.onEnter = this.onEnter.bind(this);
        this.onLeave = this.onLeave.bind(this);
        this.onFocusIn = this.onFocusIn.bind(this);
        this.onFocusOut = this.onFocusOut.bind(this);
        this.onVisibility = this.onVisibility.bind(this);
        this.onScrollHint = this.onScrollHint.bind(this);

        this.bind();
        this.syncAutoplay();
      }

      bind() {
        this.dots.forEach((d) => d.addEventListener('click', this.onDotClick));
        this.root.addEventListener('keydown', this.onKeydown);

        /* ⚠️ 无暂停按钮 —— 这是明知的取舍,不是疏忽,别当 bug「顺手修回来」。
           智鹏 2026-08-27 拍板去掉、2026-08-28 复审后重申不加,依据是 SOÉJU 同位置
           实测也没有任何暂停控件(2026-08-28 实查:0 个)。
           代价说清楚:自动轮播没有可持续的暂停控件,**不满足 WCAG 2.2.2**;
           下面这三种自动暂停(鼠标移入 / 手指触到 / 标签页切走)只是代偿,
           对纯键盘与读屏用户不等价。要合规只有两条路:加回暂停键,或关掉自动播放。 */
        this.root.addEventListener('mouseenter', this.onEnter);
        this.root.addEventListener('mouseleave', this.onLeave);
        /* pointerenter 必须配对 pointerleave:触屏点一下会触发 enter,
           若不配对、浏览器又没合成 mouseleave,轮播会永久停住。 */
        this.root.addEventListener('pointerenter', this.onEnter);
        this.root.addEventListener('pointerleave', this.onLeave);
        this.root.addEventListener('focusin', this.onFocusIn);
        this.root.addEventListener('focusout', this.onFocusOut);
        document.addEventListener('visibilitychange', this.onVisibility);

        this.hint = this.root.querySelector('[data-ayunel-hero-scroll]');
        if (this.hint) this.hint.addEventListener('click', this.onScrollHint);
      }

      destroy() {
        this.stopTimer();
        if (this.prevTimer) window.clearTimeout(this.prevTimer);
        this.dots.forEach((d) => d.removeEventListener('click', this.onDotClick));
        this.root.removeEventListener('keydown', this.onKeydown);
        this.root.removeEventListener('mouseenter', this.onEnter);
        this.root.removeEventListener('mouseleave', this.onLeave);
        this.root.removeEventListener('pointerenter', this.onEnter);
        this.root.removeEventListener('pointerleave', this.onLeave);
        this.root.removeEventListener('focusin', this.onFocusIn);
        this.root.removeEventListener('focusout', this.onFocusOut);
        document.removeEventListener('visibilitychange', this.onVisibility);
        if (this.hint) this.hint.removeEventListener('click', this.onScrollHint);
      }

      show(next) {
        if (!this.slides.length) return;
        const len = this.slides.length;
        const i = ((next % len) + len) % len;
        if (i === this.index) return;

        /* 淡入没走完就再切,会把上一张从半透明强行拉回不透明(data-prev 带 transition:none),
           肉眼是一次跳帧。所以这一轮先排队,等淡完再执行 —— 只保留最后一个目标。 */
        if (this.transitioning) {
          this.pendingIndex = i;
          return;
        }
        this.transitioning = true;

        /* 旧张沉到下层并保持不透明,直到新张淡完 —— 见 CSS 里 [data-prev] 的注释。
           ⚠️ 先无条件清掉所有 data-prev:快速连切(A→B→C)时,若只 clearTimeout,
           A 的 data-prev 会永远留着 —— 之后切回 A,它同时带 data-active 与 data-prev,
           而 [data-prev] 规则在后、会赢,A 就变成「瞬间出现在下层」而不是淡入。 */
        this.slides.forEach((s) => s.removeAttribute('data-prev'));
        if (this.prevTimer) window.clearTimeout(this.prevTimer);

        const prevEl = this.slides[this.index];
        if (prevEl) prevEl.setAttribute('data-prev', '');
        this.prevTimer = window.setTimeout(() => {
          if (prevEl) prevEl.removeAttribute('data-prev');
          this.transitioning = false;
          if (this.pendingIndex !== null) {
            const queued = this.pendingIndex;
            this.pendingIndex = null;
            this.show(queued);
          }
        }, this.fadeMs);

        this.slides.forEach((s, n) => {
          const active = n === i;
          s.toggleAttribute('data-active', active);
          /* 隐藏张对读屏软件与 Tab 键都不可达 */
          if (active) {
            s.removeAttribute('aria-hidden');
            if (s.tagName === 'A') s.removeAttribute('tabindex');
          } else {
            s.setAttribute('aria-hidden', 'true');
            if (s.tagName === 'A') s.setAttribute('tabindex', '-1');
          }
        });
        this.dots.forEach((d, n) => {
          if (n === i) d.setAttribute('aria-current', 'true');
          else d.removeAttribute('aria-current');
        });
        this.index = i;
      }

      next() {
        this.show(this.index + 1);
      }

      /* ---- 自动播放状态机:唯一出入口 ------------------------------------
         任何事件只负责「登记 / 撤销一个暂停原因」,由 syncAutoplay 统一裁决跑不跑。
         别再从事件里直接开关计时器 —— 那正是「鼠标移出时焦点还在轮播里、
         却照样恢复自动播放」这类问题的来源:一个原因解除会盖掉另一个仍成立的原因。 */
      setPause(reason, on) {
        if (on) this.pauseReasons.add(reason);
        else this.pauseReasons.delete(reason);
        this.syncAutoplay();
      }

      syncAutoplay() {
        const blockers = [...this.pauseReasons];
        if (this.slides.length < 2) blockers.push('single');
        if (this.interval <= 0) blockers.push('off');
        if (this.reduce) blockers.push('reduced-motion'); // 用户要求减少动效时不自动播放

        this.stopTimer();
        if (blockers.length === 0) {
          this.timer = window.setInterval(() => this.next(), this.interval);
        }

        /* 把状态挂到 DOM 上:排查「为什么不动 / 为什么该停没停」时直接看这两个属性,
           不用去猜内部状态,也不用靠掐表等一轮间隔。 */
        this.root.dataset.autoplayState = blockers.length === 0 ? 'running' : 'paused';
        if (blockers.length) this.root.dataset.autoplayBlockedBy = blockers.join(',');
        else delete this.root.dataset.autoplayBlockedBy;
      }

      stopTimer() {
        if (this.timer) window.clearInterval(this.timer);
        this.timer = null;
      }

      onEnter() {
        this.setPause('pointer', true);
      }

      onLeave() {
        this.setPause('pointer', false);
      }

      onFocusIn() {
        this.setPause('focus', true);
      }

      onFocusOut() {
        /* focusout 先于 focusin 触发:焦点在轮播内部移动时会瞬间误判成「离开」。
           下一帧再确认焦点是不是真的不在轮播里了。 */
        window.setTimeout(() => {
          if (!this.root.contains(document.activeElement)) this.setPause('focus', false);
        }, 0);
      }

      onVisibility() {
        this.setPause('hidden', document.hidden);
      }

      onDotClick(event) {
        const i = parseInt(event.currentTarget.dataset.ayunelHeroDot, 10);
        if (Number.isNaN(i)) return;
        this.show(i);
        /* 不无条件恢复:此刻鼠标/焦点多半还在轮播里,那两个暂停原因仍然成立。
           WAI carousel 规范也要求焦点进入后不要自动恢复轮播。 */
        this.syncAutoplay();
      }

      onKeydown(event) {
        if (event.key === 'ArrowRight') this.show(this.index + 1);
        else if (event.key === 'ArrowLeft') this.show(this.index - 1);
        else return;
        this.syncAutoplay();
      }

      onScrollHint() {
        /* ⚠️ 新版 Horizon 的滚动容器是 .page-wrapper(body/html 是 overflow:hidden
           + 视口高),window.scrollTo 完全没反应且不报错。 */
        const scroller = document.querySelector('.page-wrapper');
        const section = this.root.closest('.shopify-section') || this.root;
        const next = section && section.nextElementSibling;
        if (!next) return;

        const behavior = this.reduce ? 'auto' : 'smooth';
        if (scroller && scroller.scrollHeight > scroller.clientHeight) {
          scroller.scrollTo({ top: scroller.scrollTop + next.getBoundingClientRect().top, behavior });
        } else {
          window.scrollTo({ top: window.scrollY + next.getBoundingClientRect().top, behavior });
        }
      }
    }

    const registry = new WeakMap();

    function initAll(scope) {
      const root = scope && scope.querySelectorAll ? scope : document;
      root.querySelectorAll('[data-ayunel-hero]').forEach((el) => {
        if (registry.has(el)) return;
        registry.set(el, new AyunelHero(el));
      });
    }

    function teardown(scope) {
      const root = scope && scope.querySelectorAll ? scope : document;
      root.querySelectorAll('[data-ayunel-hero]').forEach((el) => {
        const inst = registry.get(el);
        if (inst) {
          inst.destroy();
          registry.delete(el);
        }
      });
    }

    /* bundle 可能在 DOMContentLoaded 之前或之后加载,两条路都跑(有幂等守卫) */
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAll(document));
    } else {
      initAll(document);
    }

    /* Customizer 里编辑 section 会重建 DOM,不接这两个事件后台预览就是死的 */
    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
    document.addEventListener('shopify:section:unload', (event) => teardown(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ayunel-journal-blog"]) return;
  try {
    
  /* 精选轮播开场接手(见轮播处注释 ①–③)+ 键盘只进居中那张卡。
     只用官方 slideshow-component 的公开成员:select() / current / visibleSlides 与 slideshow:select 事件,不改官方文件。
     元素被移除(编辑器重渲染)时不用收尾:观察器 / 监听都挂在本块自己的节点上,随节点回收;8 秒计时到点只是给已移除的节点挂个属性。 */
  if (!customElements.get('ayunel-journal-pick')) {
    customElements.define(
      'ayunel-journal-pick',
      class extends HTMLElement {
        connectedCallback() {
          const show = this.querySelector('slideshow-component');
          const track = show && show.querySelector('slideshow-slides');
          let centered = false;
          let userMoved = false;
          let timer = 0;

          /* 撤掉首屏左移(stylesheet 的 scripting 段);与 select(1) 同一帧 ⇒ 画面不变 */
          const settle = () => {
            clearTimeout(timer);
            this.setAttribute('data-ayn-settled', '');
          };

          if (!show || !track) {
            settle();
            return;
          }

          /* 两侧露出的卡官方标 aria-hidden="true"(读屏看不到),它们的链接跟着不进 Tab 顺序;换卡后官方改 aria-hidden,这里跟着改 */
          const syncFocus = () => {
            for (const slide of track.querySelectorAll('slideshow-slide')) {
              const off = slide.getAttribute('aria-hidden') === 'true';
              for (const link of slide.querySelectorAll('a[href]')) {
                if (off) link.setAttribute('tabindex', '-1');
                else link.removeAttribute('tabindex');
              }
            }
          };
          syncFocus();
          new MutationObserver(syncFocus).observe(track, { subtree: true, attributes: true, attributeFilter: ['aria-hidden'] });

          /* 客人动过(箭头 / 拖 / 滑,官方事件带 userInitiated)就不再管;官方自己拨到别处(非客人)→ 当场拨回第 1 篇,同一帧、不闪 */
          show.addEventListener('slideshow:select', (event) => {
            const detail = event.detail || {};
            if (detail.userInitiated) {
              userMoved = true;
            } else if (centered && !userMoved && detail.index !== 1) {
              show.select(1, undefined, { animate: false });
            }
          });

          /* 官方 8 秒还没就绪(网慢 / 出错):先撤左移、退回从左起的原样(不坏),下面照样等它,就绪了再居中 */
          timer = setTimeout(settle, 8000);

          const started = performance.now();
          customElements.whenDefined('slideshow-component').then(() => {
            const step = () => {
              /* 我们还没动过轨道它就不在起点 = 客人先滑了 → 不抢 */
              if (userMoved || track.scrollLeft > 1) {
                settle();
                return;
              }
              /* visibleSlides 非空 = 官方初始化那一帧已过(它只在「一张都不可见」时拨回第 0 张),此时接手不会被拨回。
                 先撤左移、再 select:官方 select 读 offsetLeft 会当场重排,按撤掉后的位置滚;两步同一帧、中间态不上屏。
                 顺序反过来不行(预览实测):带着左移滚到位,浏览器的吸附会认成「对齐了第 2 篇」,撤掉左移后跟着第 2 篇多滚一张 */
              if (show.visibleSlides && show.visibleSlides.length > 0) {
                settle();
                show.select(1, undefined, { animate: false });
                centered = show.current === 1;
                return;
              }
              if (performance.now() - started < 20000) requestAnimationFrame(step);
            };
            requestAnimationFrame(step);
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ayunel-link-in-bio"] && !Shopify.designMode) return;
  try {
    
  function initAyunelLinkBio(root) {
    if (root.dataset.ayunelLinkbioReady === 'true') return;
    root.dataset.ayunelLinkbioReady = 'true';

    const controller = new AbortController();

    root.addEventListener('click', (event) => {
      if (!(event.target instanceof Element)) return;
      const link = event.target.closest('a[data-linkbio-label]');
      if (!link) return;

      try {
        if (window.Shopify?.analytics?.publish) {
          Shopify.analytics.publish('ayunel_linkbio_click', {
            label: link.getAttribute('data-linkbio-label'),
            href: link.getAttribute('href')
          });
        }
      } catch (error) {
        void error;
      }
    }, { passive: true, signal: controller.signal });

    document.addEventListener('shopify:section:unload', (event) => {
      if (event.target.contains(root)) controller.abort();
    }, { signal: controller.signal });
  }

  document.querySelectorAll('[data-ayunel-linkbio]').forEach(initAyunelLinkBio);

  document.addEventListener('shopify:section:load', (event) => {
    if (!(event.target instanceof Element)) return;
    const root = event.target.querySelector('[data-ayunel-linkbio]');
    if (root) initAyunelLinkBio(root);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow"] && !Shopify.designMode) return;
  try {
    
  /* AYUNEL OVERRIDE — 往下看提示:滚到 banner 之后的第一屏内容
     ⚠️ 新版 Horizon 的滚动容器是 .page-wrapper(body/html 被设成 overflow:hidden + 视口高),
        用 window.scrollTo 完全没反应且不报错。所有滚动逻辑都要认这个容器。 */
  document.addEventListener('click', (event) => {
    const hint = event.target.closest('[data-ayunel-scroll-hint]');
    if (!hint) return;

    const scroller = document.querySelector('.page-wrapper');
    const section = hint.closest('.shopify-section') || hint.closest('.slideshow-section');
    const next = section && section.nextElementSibling;
    if (!next) return;

    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const behavior = reduce ? 'auto' : 'smooth';

    if (scroller && scroller.scrollHeight > scroller.clientHeight) {
      const top = scroller.scrollTop + next.getBoundingClientRect().top;
      scroller.scrollTo({ top, behavior });
    } else {
      const top = window.scrollY + next.getBoundingClientRect().top;
      window.scrollTo({ top, behavior });
    }
  });

  } catch(e) { console.error(e); }
})();
})();
